import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { TcPage } from '@tc/core';
import { IPageState } from '@tc/store';

@Component({
  selector: 'app-interactions-feed-page',
  templateUrl: './interactions-feed-page.component.html',
  styleUrls: ['./interactions-feed-page.component.scss'],
})
export class InteractionsFeedPageComponent extends TcPage implements OnInit {
  constructor(store: Store<any>) {
    super(store);
  }

  ngOnInit() {
    const pageInfo: IPageState = {
      title: 'interactions-feed-page.title',
    };

    this.pageInfo = pageInfo;

    super.ngOnInit();
  }
}
